import React, { useState, useEffect } from 'react';

const BirthDateInput = ({ value, onChange, className, required }) => {
    // value is expected to be in YYYY-MM-DD format
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');

    useEffect(() => {
        if (value) {
            const [y, m, d] = value.split('-');
            setDay(d || '');
            setMonth(m || '');
            setYear(y || '');
        }
    }, [value]);

    const handleDateChange = (newDay, newMonth, newYear) => {
        if (newDay && newMonth && newYear) {
            // Ensure padding for day and month
            const paddedDay = newDay.padStart(2, '0');
            const paddedMonth = newMonth.padStart(2, '0');
            onChange(`${newYear}-${paddedMonth}-${paddedDay}`);
        } else {
            onChange('');
        }
    };

    const onDayChange = (e) => {
        const val = e.target.value.slice(0, 2).replace(/\D/g, '');
        if (val === '' || (parseInt(val) >= 1 && parseInt(val) <= 31)) {
            setDay(val);
            handleDateChange(val, month, year);
        }
    };

    const onMonthChange = (e) => {
        const val = e.target.value;
        setMonth(val);
        handleDateChange(day, val, year);
    };

    const onYearChange = (e) => {
        const val = e.target.value.slice(0, 4).replace(/\D/g, '');
        setYear(val);
        handleDateChange(day, month, val);
    };

    const months = [
        { value: '01', label: 'Enero' },
        { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' },
        { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' },
    ];

    const subInputClass = "bg-white/50 border border-gray-200 p-2 rounded-xl focus:bg-white focus:ring-2 focus:ring-[#f8485e]/20 outline-none transition-all text-center font-bold text-gray-700";

    return (
        <div className="flex gap-4 mt-1 w-full max-w-sm">
            <div className="w-16 md:w-20 flex flex-col gap-1">
                <span className="text-[10px] text-gray-400 font-bold uppercase ml-1">Día</span>
                <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="DD"
                    value={day}
                    onChange={onDayChange}
                    className={subInputClass}
                    required={required}
                />
            </div>
            <div className="flex-1 flex flex-col gap-1">
                <span className="text-[10px] text-gray-400 font-bold uppercase ml-1">Mes</span>
                <select
                    value={month}
                    onChange={onMonthChange}
                    className={`${subInputClass} text-left px-3`}
                    required={required}
                >
                    <option value="">Selecciona</option>
                    {months.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                </select>
            </div>
            <div className="w-20 md:w-24 flex flex-col gap-1">
                <span className="text-[10px] text-gray-400 font-bold uppercase ml-1">Año</span>
                <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="AAAA"
                    value={year}
                    onChange={onYearChange}
                    className={subInputClass}
                    required={required}
                />
            </div>
        </div>
    );
};

export default BirthDateInput;
